import * as React from "react";
import Svg, { Defs, LinearGradient, Path, Stop } from "react-native-svg";
import { preventTabbing } from "application/components/CONST";

type Props = {
  isDark: boolean;
};

const Logo = ({ isDark }: Props) => {
  return (
    <Svg
      width={154}
      height={30}
      viewBox="0 0 154 30"
      fill="none"
      {...preventTabbing}
    >
      <Path
        d="M150.341 7.75a9.728 9.728 0 00-4.09-2.56c-2.888-.942-5.93-.556-8.333.845-.996-2.511-3.118-4.588-6.032-5.53a10.326 10.326 0 00-4.907-.362c-3.425.555-6.416 2.825-7.643 6.134-.358.941-.511 1.907-.537 2.873-.434 3.598 2.071 8.646 4.755 12.848a10.845 10.845 0 01-3.553 4.25c-.384.265-.23.87.255.918 2.531.241 4.754 0 6.595-.411 1.38 1.835 2.377 3.019 2.377 3.019s17.56-3.864 21.649-10.119a9.152 9.152 0 001.457-2.56c1.202-3.356.333-6.882-1.993-9.345z"
        fill="url(#prefix__paint0_linear)"
        {...preventTabbing}
      />
      <Path
        d="M150.341 7.75a9.728 9.728 0 00-4.09-2.56c-2.888-.942-5.93-.556-8.333.845-.996-2.511-3.118-4.588-6.032-5.53a10.326 10.326 0 00-4.907-.362c-3.425.555-6.416 2.825-7.643 6.134-.358.941-.511 1.907-.537 2.873-.434 3.598 2.071 8.646 4.755 12.848a10.845 10.845 0 01-3.553 4.25c-.384.265-.23.87.255.918 2.531.241 4.754 0 6.595-.411 1.38 1.835 2.377 3.019 2.377 3.019s17.56-3.864 21.649-10.119a9.152 9.152 0 001.457-2.56c1.202-3.356.333-6.882-1.993-9.345z"
        fill="url(#prefix__paint1_linear)"
        {...preventTabbing}
      />
      <Path
        d="M4.468 24.895h7.137v3.329H0v-17.96h4.468v14.631zM19.299 15.243c1.04 0 1.987.152 2.842.457.855.303 1.586.74 2.194 1.306a5.737 5.737 0 011.427 2.071c.344.805.516 1.714.516 2.724 0 1.02-.172 1.94-.515 2.762a5.856 5.856 0 01-1.428 2.083c-.608.567-1.34 1.007-2.194 1.319-.855.304-1.802.456-2.842.456-1.049 0-2.005-.152-2.868-.456a6.678 6.678 0 01-2.221-1.319 6.003 6.003 0 01-1.44-2.083c-.336-.822-.503-1.743-.503-2.762 0-1.01.167-1.918.502-2.724a5.88 5.88 0 011.441-2.07 6.515 6.515 0 012.22-1.308c.864-.304 1.82-.456 2.869-.456zm0 10.343c.943 0 1.634-.308 2.075-.925.45-.624.674-1.57.674-2.835s-.224-2.207-.674-2.823c-.44-.616-1.132-.924-2.075-.924-.97 0-1.679.308-2.128.924-.45.616-.674 1.558-.674 2.823 0 1.266.224 2.21.674 2.835.45.617 1.159.925 2.128.925zM35.598 28.224H31.87L26.557 15.44h3.41c.29 0 .533.065.727.197a.93.93 0 01.41.468l1.903 5.732c.15.469.291.925.423 1.369.141.444.26.887.357 1.331.097-.444.216-.887.357-1.331.14-.444.29-.9.45-1.369l1.982-5.732a.943.943 0 01.397-.468c.194-.132.423-.197.687-.197h3.252l-5.314 12.783zM47.975 15.243c.908 0 1.736.132 2.485.395a5.407 5.407 0 011.943 1.146c.547.502.97 1.118 1.27 1.85.308.723.462 1.544.462 2.465 0 .287-.013.522-.04.702a1.06 1.06 0 01-.145.432.545.545 0 01-.29.222 1.358 1.358 0 01-.45.061h-7.905c.133 1.069.48 1.845 1.044 2.33.565.477 1.292.715 2.182.715.475 0 .885-.053 1.229-.16.343-.107.647-.226.912-.358l.74-.357c.23-.107.467-.16.714-.16.326 0 .573.11.74.332l1.19 1.369a6.07 6.07 0 01-1.375 1.11c-.485.279-.987.5-1.507.665a8.482 8.482 0 01-1.546.32c-.511.066-1 .1-1.468.1a8.36 8.36 0 01-2.71-.432 6.445 6.445 0 01-2.207-1.307c-.625-.575-1.123-1.29-1.493-2.145-.362-.855-.542-1.85-.542-2.983 0-.855.154-1.664.462-2.429a6.07 6.07 0 011.349-2.009 6.54 6.54 0 012.128-1.368c.837-.337 1.78-.506 2.828-.506zm.08 2.638c-.785 0-1.397.21-1.838.629-.44.411-.731 1.007-.872 1.787h5.115c0-.304-.044-.6-.132-.887a1.924 1.924 0 00-.41-.764 1.975 1.975 0 00-.74-.555c-.308-.14-.683-.21-1.123-.21zM78.411 28.224h-4.494V20.63h-7.825v7.594h-4.494v-17.96h4.494v7.506h7.825v-7.507h4.494v17.96zM86.47 28.224h-4.494v-17.96h4.495v17.96zM94.938 28.224h-4.494v-17.96h4.494v17.96zM112.5 10.263v3.304h-5.419v14.657h-4.468V13.567h-5.42v-3.304H112.5z"
        fill={isDark ? "#110133" : "white"}
        {...preventTabbing}
      />
      <Path
        d="M128.4 15.156c-.957 0-1.733-.722-1.733-1.611 0-.89.776-1.611 1.733-1.611.957 0 1.733.721 1.733 1.61 0 .89-.776 1.612-1.733 1.612zM131.494 4.688c.438 0 .794.33.794.737v6.066l5.181.01c.846 0 1.622.435 2.02 1.129l4.871 8.484c.263.46.076 1.03-.418 1.275-.495.245-1.109.07-1.372-.388l-4.044-7.048-2.854 6.94c-.2.487-.787.73-1.31.545-.523-.186-.785-.731-.585-1.217l2.311-5.613h-3.8v6.154c0 .408-.356.738-.794.738-.438 0-.794-.33-.794-.738V5.425c0-.407.356-.737.794-.737z"
        fill="#fff"
        {...preventTabbing}
      />
      <Defs {...preventTabbing}>
        <LinearGradient
          id="prefix__paint0_linear"
          x1={121.919}
          y1={2.494}
          x2={141.706}
          y2={27.453}
          gradientUnits="userSpaceOnUse"
          {...preventTabbing}
        >
          <Stop offset={0.217} stopColor="#034EA2" {...preventTabbing} />
          <Stop offset={1} stopColor="#00B9F2" {...preventTabbing} />
        </LinearGradient>
        <LinearGradient
          id="prefix__paint1_linear"
          x1={153.235}
          y1={30}
          x2={120.781}
          y2={-1.75}
          gradientUnits="userSpaceOnUse"
          {...preventTabbing}
        >
          <Stop stopColor="#00918E" {...preventTabbing} />
          <Stop offset={1} stopColor="#4DD599" {...preventTabbing} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};

export default Logo;
